import { FC } from 'react';
import styles from './loading.module.css';
import loading from '../../images/loading.gif';


export const Loading:FC = () => {
    return (
        <div className={styles.loaderContainer}>
            <h2 
            className={styles.title}
            >Не закрывайте это окно, ваше видео создаётся и скоро будет доступно<br/>для просмотра и скачивания</h2>
            <img
            className={styles.loader}
            src={loading} 
            alt="Загрузка..."
            />
        </div>
    )
}